import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class AmenityIconService {
  private readonly titleToSvg: Record<string, string> = {
    // Examples. Add more mappings as needed to match parkingFeatures titles
    'Security Cameras': `
<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="none"/>
  <path d="M3 10l10 3 6-4-10-3-6 4z" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <path d="M5 17h6a2 2 0 0 0 2-2v-1" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <path d="M11 13l-3 5" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</svg>`,
    'Covered Parking': `
<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="none"/>
  <path d="M3 10l9-6 9 6" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <rect x="6" y="10" width="12" height="8" rx="2" stroke="#1F2741" stroke-width="1.8" fill="none"/>
</svg>`,
    'EV Charging': `
<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="none"/>
  <path d="M7 20V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v14" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15 8h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 9l-2 4h3l-2 4" stroke="#1F2741" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
  };

  constructor(private readonly sanitizer: DomSanitizer) {}

  getSvgByTitle(title: string): SafeHtml | null {
    const raw = this.titleToSvg[title];
    if (!raw) return null;
    return this.sanitizer.bypassSecurityTrustHtml(raw);
  }

  hasTitle(title: string): boolean {
    return !!this.titleToSvg[title];
  }
}


